<template>
  <AlertHandler />
  <CheckAccessHandler />
  <GlobalEventsHandler />
  <router-view v-if="inited" />
</template>

<script>
window.VERSION_CLIENT = "8.31.10";

import { defineComponent, defineAsyncComponent } from "vue";
import { LocalStorage } from "quasar";
import GlobalEventsHandler from "src/components/core/global-events-handler.vue";
import EventBus from "src/services/event-bus";

export default defineComponent({
  name: "App",
  components: {
    AlertHandler: defineAsyncComponent(() =>
      import("src/components/core/alert-handler.vue")
    ),
    CheckAccessHandler: defineAsyncComponent(() =>
      import("src/components/core/check-access-handler.vue")
    ),
    GlobalEventsHandler
  },
  data() {
    return {
      inited: false
    };
  },
  computed: {
    settings() {
      return this.$store.getters["settings/allSettings"];
    }
  },
  methods: {
    async init(needResetGoldenLayout = true) {
      // console.log("App init");
      this.$q.loading.show();
      window.$store = this.$store; // костыль для использования $store в *.js и *.ts
      await this.$store.dispatch("settings/init");
      //#region костыль (nextTick) для того, чтобы успел инициализироваться GlobalEventsHandler
      await this.$nextTick(() => {
        if (!LocalStorage.has("dialogId")) {
          EventBus.$emit("session:reset");
        }
      });
      //#endregion
      if (needResetGoldenLayout) {
        EventBus.$emit("resetGoldenLayout");
      }
      this.$q.loading.hide();
      this.inited = true;
      // дублируем проверку, так как такая же проверка в Router.beforeResolve выполняется раньше
      this.checkDenyAnonymousMode();
    },
    checkDenyAnonymousMode() {
      if (
        this.$route.meta.checkAvailabilityAnonymousMode &&
        this.settings.denyAnonymousMode &&
        this.$store.getters["user/isAnonymous"]
      ) {
        this.$router.push({ name: "auth" });
      }
    },
    async initAudio() {
      // console.log('initAudio', new Date())
      await this.$store.dispatch('settings/initAudio');
      document.removeEventListener('click', this.initAudio);
    },
  },
  beforeCreate() {
    // console.log("App beforeCreate");
  },
  created() {
    // console.log("App created");
    this.init(false);
    EventBus.$on("appInit", this.init);
  },
  beforeMount() {
    // console.log("App beforeMount");
  },
  mounted() {
    // console.log("App mounted");
    document.addEventListener('click', this.initAudio);
  },
  beforeUnmount() {
    // console.log("App beforeUnmount");
    EventBus.$off("appInit", this.init);
    document.removeEventListener('click', this.initAudio);
  },
  unmounted() {
    // console.log("App unmounted");
  }
});
</script>

<style lang="scss" scoped>
</style>
